export function useUser() {
    const store = useStore()
    return computed<typeof store.auth.user>(() => store.auth?.user)
}
  